if (!customElements.get('adev-site-header')) {
    customElements.define('adev-site-header', class adevSiteHeader extends HTMLElement {
        constructor() {
            super();
        }

        cssVariables() {
            const headerEl = document.querySelector('header[data-adev-site-header]');
            document.documentElement.style.setProperty('--adev-header-height', `${headerEl.offsetHeight}px`);
        }

        connectedCallback() {
            this.cssVariables();

            window.addEventListener('resize', this.cssVariables.bind(this));
            window.addEventListener('orientationchange', this.cssVariables.bind(this));

            const headerSearch = document.querySelector('adev-site-header-search');
            if (headerSearch) {
                const openSearch = this.querySelector('[data-adev-header-open="search"]');
                openSearch.addEventListener('click', (e) => {
                    e.preventDefault();
                    headerSearch.open();
                });
            }

            const mobileMenu = document.querySelector('adev-mobile-menu');
            if (mobileMenu) {
                const openMobileMenu = this.querySelector('[data-adev-header-open="mobile-menu"]');
                openMobileMenu.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (mobileMenu.isOpened()) {
                        mobileMenu.close();
                    } else {
                        mobileMenu.open();
                    }
                });
            }

            const openCart = this.querySelector('[data-adev-header-open="cart"]');
            if (openCart) {
                openCart.addEventListener('click', (e) => {
                    e.preventDefault();

                    const cart = document.querySelector('cart-drawer');
                    if (cart) {
                        cart.open();
                    }
                });
            }
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this.cssVariables);
            window.removeEventListener('orientationchange', this.cssVariables);
        }

    });
}

if (!customElements.get('adev-header-menu')) {
    customElements.define('adev-header-menu', class adevHeaderMenu extends HTMLElement {
        constructor() {
            super();
            this.handleOutsideClick = this.handleOutsideClick.bind(this);
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-header-submenu="li"]').forEach(li => {
                const a = li.querySelector('[data-adev-header-submenu="a"]');
                const submenu = li.querySelector('[data-adev-header-submenu="submenu"]');

                a.addEventListener('click', (e) => {
                    e.preventDefault();

                    this.closeAllMegamenus();

                    if (submenu.classList.contains('active')) {
                        a.classList.remove('active');
                        submenu.classList.remove('active');
                        submenu.setAttribute('tabindex', '-1');
                    } else {
                        this.closeAllSubmenus();

                        a.classList.add('active');
                        submenu.classList.add('active');
                        submenu.setAttribute('tabindex', '0');
                    }
                });

                const subLis = li.querySelectorAll('[data-adev-header-submenu="sub-li"]');
                subLis.forEach(subLi => {
                    const subA = subLi.querySelector('[data-adev-header-submenu="sub-a"]');
                    const subSubmenu = subLi.querySelector('[data-adev-header-submenu="sub-submenu"]');

                    subA.addEventListener('click', (e) => {
                        e.preventDefault();

                        if (subSubmenu.classList.contains('active')) {
                            subA.classList.remove('active');
                            subSubmenu.classList.remove('active');
                            subSubmenu.setAttribute('tabindex', '-1');
                        } else {
                            subA.classList.add('active');
                            subSubmenu.classList.add('active');
                            subSubmenu.setAttribute('tabindex', '0');
                        }
                    });
                });

            });

            this.querySelectorAll('[data-adev-header-megamenu="li"]').forEach(li => {
                const id = li.getAttribute('data-id');
                const a = li.querySelector('[data-adev-header-megamenu="a"]');
                const megamenu = document.querySelector(`[data-adev-header-megamenu-id="${id}"]`);

                a.addEventListener('click', (e) => {
                    e.preventDefault();

                    this.closeAllSubmenus();

                    if (megamenu.classList.contains('active')) {
                        a.classList.remove('active');
                        megamenu.classList.remove('active');
                        megamenu.setAttribute('tabindex', '-1');
                    } else {
                        a.classList.add('active');
                        megamenu.classList.add('active');
                        megamenu.setAttribute('tabindex', '0');
                    }
                });
            });

            document.addEventListener('click', this.handleOutsideClick);
        }

        disconnectedCallback() {
            document.removeEventListener('click', this.handleOutsideClick);
        }

        handleOutsideClick(event) {
            if (!this.contains(event.target)) {
                this.closeAllSubmenus();
            }

            if (!event.target.closest('[data-adev-header-megamenu="li"]') && !event.target.closest('[data-adev-header-megamenu-id]')) {
                this.closeAllMegamenus();
            }
        }

        closeAllSubmenus() {
            this.querySelectorAll('[data-adev-header-submenu="a"].active').forEach(a => {
                a.classList.remove('active');
            });
            
            this.querySelectorAll('[data-adev-header-submenu="submenu"].active').forEach(submenu => {
                submenu.classList.remove('active');
                submenu.setAttribute('tabindex', '-1');
            });
        }

        closeAllMegamenus() {
            this.querySelectorAll('[data-adev-header-megamenu="a"].active').forEach(a => {
                a.classList.remove('active');
            });

            document.querySelectorAll('[data-adev-header-megamenu-id].active').forEach(megamenu => {
                megamenu.classList.remove('active');
                megamenu.setAttribute('tabindex', '-1');
            });
        }

    });
}

if (!customElements.get('adev-site-header-search')) {
    customElements.define('adev-site-header-search', class adevSiteHeaderSearch extends HTMLElement {
        constructor() {
            super();
            this.abortController = new AbortController();
            this.debounceTimeout = null;
        }

        open() {
            this.classList.add('active');
        }

        close() {
            this.classList.remove('active');
            this.clearResults();
        }

        connectedCallback() {
            this.closeButton();
            this.predictiveSearch();
        }

        closeButton() {
            const closeButton = this.querySelector('[data-adev-header-search="close"]');
            if (closeButton) {
                closeButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.close();
                });
            }
        }

        predictiveSearch() {
            const inputEl = this.querySelector('[data-adev-header-search="input"]');
            const resultsWrap = this.querySelector('[data-adev-header-search="results-wrap"]');

            inputEl.addEventListener('input', () => {
                const query = inputEl.value.trim();

                clearTimeout(this.debounceTimeout);

                if (query) {
                    resultsWrap.classList.add('active'); // Show loading
                    resultsWrap.classList.remove('ready'); // Hide results
                    this.debounceTimeout = setTimeout(() => {
                        this.performSearch(query);
                    }, 300); // 300ms debounce
                } else {
                    resultsWrap.classList.remove('active');
                    resultsWrap.classList.remove('ready');
                    this.clearResults();
                }
            });
        }

        performSearch(query) {
            // Cancel previous request if any
            if (this.abortController) {
                this.abortController.abort();
            }
            this.abortController = new AbortController();

            fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(query)}&section_id=predictive-search`, {
                signal: this.abortController.signal,
            })
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }
                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('#shopify-section-predictive-search').innerHTML;

                this.renderSearchResults(resultsMarkup);
            })
            .catch((error) => {
                if (error?.code === 20) {
                    return;
                }
                this.close();
                throw error;
            });
        }

        renderSearchResults(resultsMarkup) {
            const resultsWrap = this.querySelector('[data-adev-header-search="results-wrap"]');
            const resultsHtml = this.querySelector('[data-adev-header-search="results-html"]');

            resultsHtml.innerHTML = resultsMarkup;
            resultsWrap.classList.add('active');
            resultsWrap.classList.add('ready');
        }

        clearResults() {
            const resultsHtml = this.querySelector('[data-adev-header-search="results-html"]');
            if (resultsHtml) {
                resultsHtml.innerHTML = '';
            }
        }
    });
}


if (!customElements.get('adev-mobile-menu')) {
    customElements.define('adev-mobile-menu', class adevMobileMenu extends HTMLElement {
        constructor() {
            super();

            this._isOpened = false;

            window.matchMedia('(min-width: 992px)').addEventListener('change', (e) => {
                if (e.matches) {
                    this.close();
                }
            });
        }

        open() {
            const openMobileMenu = document.querySelector('[data-adev-header-open="mobile-menu"]');
            this._isOpened = true;
            this.classList.add('active');
            document.body.classList.add('adev-opened--mobile-menu');
            openMobileMenu.classList.add('active');
        }

        close() {
            const openMobileMenu = document.querySelector('[data-adev-header-open="mobile-menu"]');
            this._isOpened = false;
            this.classList.remove('active');
            document.body.classList.remove('adev-opened--mobile-menu');
            openMobileMenu.classList.remove('active');
        }

        isOpened() {
            return this._isOpened;
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-mm-submenu="li"]').forEach((li) => {
                const a = li.querySelector('[data-adev-mm-submenu="a"]');
                a.addEventListener('click', (e) => {
                    e.preventDefault();

                    const submenu = li.querySelector('[data-adev-mm-submenu="submenu"]');

                    if (submenu.classList.contains('active')) {
                        submenu.classList.remove('active');
                        li.classList.remove('active');
                        submenu.setAttribute('tabindex', '-1');
                    } else {
                        submenu.classList.add('active');
                        li.classList.add('active');
                        submenu.setAttribute('tabindex', '0');
                    }

                });
            });
        }

        disconnectedCallback() {
            
        }

    });
}